var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewDlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    fill: "#F3F3F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "#E2E2E5",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.14 6.54651C13.3499 6.54656 13.5544 6.61265 13.7247 6.73541C13.8949 6.85817 14.0222 7.03138 14.0885 7.23051L14.36 8.04651H16C16.1326 8.04651 16.2598 8.09919 16.3536 8.19296C16.4473 8.28672 16.5 8.4139 16.5 8.54651C16.5 8.67912 16.4473 8.80629 16.3536 8.90006C16.2598 8.99383 16.1326 9.04651 16 9.04651L15.9985 9.08201L15.565 15.1535C15.5379 15.5318 15.3686 15.8858 15.091 16.1443C14.8134 16.4027 14.4483 16.5465 14.069 16.5465H9.931C9.55173 16.5465 9.18655 16.4027 8.90898 16.1443C8.63141 15.8858 8.46205 15.5318 8.435 15.1535L8.0015 9.08151L8 9.04651C7.86739 9.04651 7.74021 8.99383 7.64645 8.90006C7.55268 8.80629 7.5 8.67912 7.5 8.54651C7.5 8.4139 7.55268 8.28672 7.64645 8.19296C7.74021 8.09919 7.86739 8.04651 8 8.04651H9.64L9.9115 7.23051C9.97785 7.0313 10.1052 6.85803 10.2755 6.73527C10.4459 6.6125 10.6505 6.54646 10.8605 6.54651H13.14ZM10.5 10.5465C10.3775 10.5465 10.2593 10.5915 10.1678 10.6729C10.0763 10.7542 10.0178 10.8664 10.0035 10.988L10 11.0465V14.0465C10.0001 14.1739 10.0489 14.2965 10.1364 14.3892C10.2239 14.4819 10.3435 14.5376 10.4707 14.5451C10.5979 14.5526 10.7232 14.5112 10.8209 14.4294C10.9186 14.3476 10.9814 14.2316 10.9965 14.105L11 14.0465V11.0465C11 10.9139 10.9473 10.7867 10.8536 10.693C10.7598 10.5992 10.6326 10.5465 10.5 10.5465ZM13.5 10.5465C13.3674 10.5465 13.2402 10.5992 13.1464 10.693C13.0527 10.7867 13 10.9139 13 11.0465V14.0465C13 14.1791 13.0527 14.3063 13.1464 14.4001C13.2402 14.4938 13.3674 14.5465 13.5 14.5465C13.6326 14.5465 13.7598 14.4938 13.8536 14.4001C13.9473 14.3063 14 14.1791 14 14.0465V11.0465C14 10.9139 13.9473 10.7867 13.8536 10.693C13.7598 10.5992 13.6326 10.5465 13.5 10.5465ZM13.14 7.54651H10.86L10.6935 8.04651H13.3065L13.14 7.54651Z",
    fill: "#8C8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDlt);
export default __webpack_public_path__ + "static/media/View_dlt.f3c28160f4e14a405fc8b5e514766944.svg";
export { ForwardRef as ReactComponent };